import { useSyncExternalStore } from "react";
import { i18nStore } from "./i18nStore";

export const useI18n = () =>
  useSyncExternalStore(i18nStore.subscribe, i18nStore.getSnapshot, i18nStore.getSnapshot);
